import {
  CheckboxInput,
  FormItem,
  MenuPresets,
  NumberInput,
  TextInput,
} from '@framework/form';
import { RowElement } from '@framework/ui';
import { Collapse } from 'antd';
import React from 'react';
import { RichTextAdvancedInput } from '../../../../../inputs/rich-text-advanced/RichTextAdvancedInput';
import { StyledDrawerCollapse } from '../../../../../ui/drawer';
import type { IWidgetComponentProps } from '../../../IWidgetType';
import { ITableInputWidget } from './ITableInputWidget';
import { TableColumnWidgetList } from './columns/TableColumnWidgetList';
import { TableRowsWidgetList } from './rows/TableRowsWidgetList';
const { Panel } = Collapse;

export interface ITableInputWidgetConfigComponentProps
  extends IWidgetComponentProps<ITableInputWidget> {}

export function TableInputWidgetConfigComponent(
  props: ITableInputWidgetConfigComponentProps,
) {
  return (
    <div>
      <StyledDrawerCollapse
        defaultActiveKey={['general', 'rows', 'columns']}
        ghost
      >
        <Panel header="Impostazioni Generali" key="general">
          <RowElement>
            <FormItem name="code" label="Codice">
              <TextInput name="code" />
            </FormItem>
            {/* <BaseLayoutColSpanInput isTableColumn={options.isTableColumn} /> */}
            <FormItem
              name="layout.rowsLabelColumnWidth"
              label="Larghezza colonna delle etichette delle Righe"
            >
              <NumberInput name="layout.rowsLabelColumnWidth" addonAfter="%" />
            </FormItem>
          </RowElement>
          <RowElement>
            <FormItem name="layout.hideTableHeader">
              <CheckboxInput
                name="layout.hideTableHeader"
                defaultChecked={false}
              >
                Nascondi intestazione tabella
              </CheckboxInput>
            </FormItem>
            <FormItem name="layout.lightTableHeader">
              <CheckboxInput
                name="layout.lightTableHeader"
                defaultChecked={false}
              >
                Intestazione tabella con sfondo bianco
              </CheckboxInput>
            </FormItem>
          </RowElement>
          {/* Titolo Tabella */}
          {/* <FormItem name="layout.showTableTitle">
            <CheckboxInput name="layout.showTableTitle" defaultChecked={false}>
              Mostra titolo tabella
            </CheckboxInput>
          </FormItem>
          <FormItem name="layout.tableTitle" label="Titolo della tabella">
            <RichTextInput
              name="layout.tableTitle"
              rows={2}
              menus={MenuPresets.Minimal}
            />
          </FormItem> */}
        </Panel>

        <Panel header="Righe Tabella (Variabile Campo)" key="rows">
          <div>
            <FormItem name="label" label="Etichetta per le Righe">
              <RichTextAdvancedInput
                name="label"
                rows={2}
                menus={MenuPresets.Minimal}
              />
            </FormItem>
          </div>

          <TableRowsWidgetList name="rows" />
        </Panel>
        <Panel header="Colonne Tabella (Campi di input)" key="columns">
          <TableColumnWidgetList name="columns" />
        </Panel>
      </StyledDrawerCollapse>
    </div>
  );
}
